'use strict';

const htmlEl = document.documentElement;
const navToggle = document.getElementById('navToggle');
const siteNav = document.getElementById('site-navigation');

const NAV_OPEN_CLASS = 'nav-open';

const isNavOpen = () => htmlEl.classList.contains(NAV_OPEN_CLASS);

const openNav = () => {
	htmlEl.classList.add(NAV_OPEN_CLASS);
	if (navToggle) {
		navToggle.setAttribute('aria-expanded', 'true');
		navToggle.setAttribute('aria-label', navToggle.dataset.labelClose || 'Close menu');
	}
	document.addEventListener('keydown', onEscape);
};

const closeNav = () => {
	htmlEl.classList.remove(NAV_OPEN_CLASS);
	if (navToggle) {
		navToggle.setAttribute('aria-expanded', 'false');
		navToggle.setAttribute('aria-label', navToggle.dataset.labelOpen || 'Open menu');
	}
	document.removeEventListener('keydown', onEscape);
};

const onEscape = (e) => {
	if (e.key === 'Escape') {
		closeNav();
	}
};

if (navToggle && siteNav) {
	navToggle.dataset.labelOpen = navToggle.getAttribute('aria-label') || '';
	navToggle.dataset.labelClose = 'Close menu';

	navToggle.addEventListener('click', () => {
		if (isNavOpen()) {
			closeNav();
		} else {
			openNav();
		}
	});

	siteNav.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => {
			closeNav();
		});
	});
}
